<template>
  <UiModal
    v-model="active"
    title="사진"
    size="large"
    :centered="true"
    :close-on-backdrop-click="true"
    :zIndex="999999"
    modal-class="image-preview-modal-host"
  >
    <div class="image-preview-modal-host__body">
      <img v-if="active && imageSrc" :src="imageSrc" alt="사진" :style="imgStyle" />
    </div>
  </UiModal>
</template>

<script setup>
import { computed } from 'vue';
import UiModal from '~/components/common/UI/UiModal.vue';
import { useImageModalState } from '~/composables/useImageModal';

const { active, imageSrc, imageMatchStyle } = useImageModalState();

const imgStyle = computed(() => {
  const m = imageMatchStyle.value || 'max-width:100%';
  return `${m}; max-width: 100%; max-height: 85vh; object-fit: contain;`;
});
</script>

<style scoped>
.image-preview-modal-host__body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 200px;
  text-align: center;
}

.image-preview-modal-host__body img {
  display: block;
  margin: 0 auto;
}
</style>
